import { ApiDimension, ApiMetric } from "@incendium/api";
import { Box } from "@mui/material";
import {
  ExplorerProvider,
  ExplorerSidebar,
  ExplorerTable,
} from "features/explorer";
import { TExploreConfig } from "features/explorer/types";
import withDatepicker from "HoC/withDatepicker";
import withFromTo from "HoC/withFromToProvider";
import withPagetitle from "HoC/withPagetitle";
import { useMemo, useState } from "react";
import ExplorerTopBar from "features/explorer/components/ExplorerTopBar";
import { TOP_BAR_HEIGHT } from "features/leftMenu/constants";

type Tab = "audit";

function TrafficAuditPage() {
  const [open, setOpen] = useState(false);
  const config: TExploreConfig<Tab> = useMemo(
    () => ({
      audit: {
        title: "Traffic Audit",
        desc: `Check how your urls are been mapped to channels, limited to last 2000 unique landing pages`,
        type: "top",
        ranking: [],
        analyseBy: {
          description: "Select between full url or path.",
          grouping: [
            {
              option: "Landing Page",
              dimensions: [
                ApiDimension.DIMENSION_LANDING_PAGE_FULL_URL,
                ApiDimension.DIMENSION_LANDING_PAGE_PATH,
              ],
            },
          ],
        },
      },
    }),
    [],
  );

  return (
    <ExplorerProvider configs={config} type={"audit"}>
      <Box
        sx={{
          height: `calc(100vh - ${TOP_BAR_HEIGHT}px - 165px)`,
          display: "flex",
          flexDirection: "column",
          flexWrap: "nowrap",
          gap: 2,
        }}
      >
        <ExplorerTopBar onOpenSidebar={() => setOpen(true)} />
        <Box sx={{ minHeight: 0, flexGrow: 1 }}>
          <ExplorerTable
            metrics={[ApiMetric.METRIC_SESSIONS_COUNT]}
            limit={2000}
            colWidths={{
              [ApiDimension.DIMENSION_LANDING_PAGE_FULL_URL]: 350,
              [ApiDimension.DIMENSION_LANDING_PAGE_PATH]: 350,
              [ApiDimension.DIMENSION_CHANNEL]: 155,
              [ApiDimension.DIMENSION_SOURCE]: 155,
              [ApiDimension.DIMENSION_REFERRER]: 155,
            }}
            extraDimensions={[
              ApiDimension.DIMENSION_CHANNEL,
              ApiDimension.DIMENSION_SOURCE,
              ApiDimension.DIMENSION_REFERRER,
            ]}
          />
        </Box>
        <ExplorerSidebar
          open={open}
          onClose={() => setOpen(false)}
          filterTitle="Filter Traffic Audit"
        />
      </Box>
    </ExplorerProvider>
  );
}

export default withFromTo(withDatepicker(withPagetitle(TrafficAuditPage)));
